export const dateDisplayFormat = 'DD.MM.YYYY';
export const monthYearDisplayFormat = 'MM.YYYY';
export const monthDayYearDisplayFormat = 'MM/DD/YYYY';
export const currencyDecimalSeparator = ',';
export const unicodeCharacters = {
    NON_BREAKING_SPACE: '\u00A0',
    THREE_DOTS: '\u2026',
};
export const searchFieldDebounceInterval = 1500;
export const documentContainerWidth = '600px';
export const maxNumberInputValue = '9999999999999.99999999';
export const maxNumberConversionInputValue = '99999999999999.999999999999999';
